import styled from 'styled-components';
import { Box, IconButton } from '@mui/material';
import { Container as ContainerCountControl } from '@components/shared/countControl/styles';

interface IContainerProps {
  isblocked?: boolean;
}

export const ContainerCard = styled(Box)<IContainerProps>`
  &&& {
    position: relative;
    cursor: pointer;
    background-color: ${({ theme }) => theme.white};
    border: 1px solid ${({ borderColor }) => borderColor || '#ccc'};
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 0.4rem 0.4rem;
    width: 100%;

    &.box-layout-card-collumn {
      padding: 0;
      border-radius: 0;
    }

    ${props =>
      props.isblocked &&
      `
    cursor: not-allowed;
    border: 1px solid #ccc;
    opacity: 0.8;
    filter: grayscale(0.6);

    .MuiButtonBase-root {
      cursor: not-allowed;
    }
    `};

    &:hover {
      background: ${({ theme }) => theme.grayLight};
    }
  }
`;

interface IContainerCartActive {
  active: boolean;
  $isShowSupplier?: boolean;
}

export const ContainerCardShopping = styled.div<IContainerCartActive>`
  ${props =>
    props.active
      ? {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: props.$isShowSupplier ? 'flex-start' : 'center',
          height: '100%',
          position: 'relative'
        }
      : {
          display: 'none'
        }};
`;

export const ContainerCardShoppingRow = styled.div<IContainerCartActive>`
  ${props =>
    props.active
      ? {
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }
      : {
          display: 'none'
        }};

  > .products-list__column {
    height: 100%;
    border-right: 1px solid #ebebeb;

    &:last-child {
      border: none;
    }
  }
`;
export const SkeletonCardShoppingRow = styled(ContainerCardShoppingRow)<
  IContainerCartActive
>`
  margin: 0.4rem 0;
`;

export const HeaderCardShopping = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.6rem;
`;

export const TitleHeaderCardShopping = styled.h5`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const BodyCardShopping = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 0;

  > img {
    width: 100%;
    max-width: 185px;
    max-height: 185px;
    min-width: 185px;
    min-height: 185px;
    object-fit: contain;
  }
`;

export const BoxButtonCart = styled(IconButton)`
  &&& {
    position: absolute !important;
    right: 0 !important;
    bottom: 0 !important;

    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;

export const ContentFindMoreSuppliers = styled.div<IContainerCartActive>`
  ${props =>
    props.active
      ? {
          display: 'flex',
          flexDirection: 'column',

          rowGap: '0.4rem',
          minHeight: '300px',
          height: '100%',

          alignItems: 'center',
          justifyContent: 'center'
        }
      : {
          display: 'flex',
          width: '100%',
          flexDirection: 'column',

          alignItems: 'center',
          justifyContent: 'center'
        }};
`;

export const Recommended = styled.p`
  color: ${({ theme }) => theme.pantone2726C};
  font-size: 0.9rem;
  font-weight: bold;
  text-align: center;
`;
export const AreaTitleCardShopping = styled.p`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.2rem;
  font-size: 0.9rem;
  margin: 0;
`;
export const AreaTitleCardShoppingSupplier = styled.p`
  font-size: 0.9rem;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
export const TitleCardShoppingSupplier = styled.span`
  font-weight: bold;
`;

export const TitleCardShopping = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-weight: bold;
`;
export const TextCardShopping = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 0.8rem;
  line-height: 1.2rem;
  margin-bottom: 0.4rem;
`;

export const FooterCardShopping = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  font-size: 1rem;

  > .MuiRadio-root {
    width: fit-content;
    margin-left: auto;
    padding: 0;
  }
`;

interface IPriceContainer {
  $hasMore2Items?: boolean;
}
export const PriceContainer = styled.div<IPriceContainer>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: ${({ $hasMore2Items }) =>
    $hasMore2Items ? 'flex-start' : 'center'};
  gap: 0.2rem;
  justify-content: ${({ $hasMore2Items }) =>
    $hasMore2Items ? 'space-between' : 'flex-end'};
  flex-wrap: wrap;

  #id-createOrder-button-add-cart {
    margin-left: ${({ $hasMore2Items }) => ($hasMore2Items ? 'auto' : '0')};
  }

  ${ContainerCountControl} {
    max-width: 100%;
  }
`;

export const PriceCardShopping = styled.span`
  font-weight: bold;
  font-size: 1rem;
  color: #000;
  white-space: nowrap;
`;

export const IconButtonCart = styled(IconButton)`
  &&& {
    width: fit-content;
    height: fit-content;

    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;

export const AwaitingAnswer = styled.span`
  color: ${({ theme }) => theme.pantone2726C};
  font-weight: bold;
  font-size: 1rem;
  margin: auto 0;
  text-align: center;
`;

